var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mhi-message"},[_c('transition-group',{staticClass:"wrapper",attrs:{"name":"list","tag":"div"}},_vm._l((_vm.messages),function(message){return _c('div',{key:message.rand_id,class:['alert message py-2 my-1', _vm.messageClass(message.type)],attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(message.text)+" ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }